import axios from "axios";
import utils from "../utils";
import constants from "../utils/constants";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: utils.config.authServices,
  timeout: 10000,
});
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
   if(navigator.onLine) {
    if (error.response) {
      if (error.response.status === 503) {
        localStorage.setItem(constants.localStorage.statusLabel, error.status)
        window.open("/#" + constants.navigationLink.serverDown, "_self")
      }
      else if (error.response.status === 500) {
        localStorage.setItem(constants.localStorage.statusLabel, error.status)
        window.open("/#" + constants.navigationLink.serverError, "_self")
      }
      return Promise.reject(error.response);
    }
    else{
      toast.error(constants.constantsErrors.serverError , { toastId : "error6"})
    }
    }
    else {
      toast.error(constants.constantsErrors.internetErrorLabel ,{toastId : "error6"})
    }
    return Promise.reject(error);
  }
);

async function login(body) {
  try {
    let response = await axiosInstance.post(constants.apiName.login, body);
    return response.data;
  } catch (error) {
    return error.data;
  }
}
async function forgotPassword(body) {
  try {
    let response = await axiosInstance.post(constants.apiName.forgot, body);
    return (response ? (response.data ? response.data : null):null);
  } catch (error) {
    return (error ? (error.data ? error.data : null):null);
  }
}
const auth = {
  login,
  forgotPassword,
};
export default auth;
